<template>
    <div id="toolbar" ref="toolbar" v-if="isMobile">
        <div @click="toggle" class="toolCollapse esri-widget--button esri-widget z-3" id="tool-collapse">
            <span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="20" height="20">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z" />
                </svg>
            </span>
        </div>
        <div id="toolCollapse" class="tool-wrapper" :class="`${show ? 'is-active' : ''}`" ref="tools">
            <div class="buttons">
                <slot></slot>
            </div>
        </div>
    </div>
    <div id="toolbar" class="collapse-panel" v-else-if="!isMobile">
        <slot></slot>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps(['isDesktop']);
const isMobile = ref(props.isDesktop != 1)
const toolbar = ref(null);
const tools = ref(null);
const show = ref(false);

function toggle() {
    show.value = !show.value
}

</script>

<style lang="scss" scoped>
    #toolbar {
        position: absolute;
        right: 0;
        z-index: 100;
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
        justify-content: flex-end;
        bottom: 26%;
        margin-right: 1.1rem;

        // &.is-desktop {
        //     bottom: 25%;
        // }
    }

    .tool-wrapper {
        position: absolute;
        background: white;
        right: 34px;
        top: 0px;
        height: 32px;
        width: 0px;
        box-shadow: 0px 2px 3px rgba(68, 68, 68, 0.3);
        animation: fade-in;
        transition: all 0.5s ease-in-out;
        padding: 0 2px;
        opacity: 0;

        &.is-active {
            width: fit-content;
            opacity: 1;
        }

        div.buttons {
            display: flex;
            justify-content: space-between;
            flex-grow: 1;
        }

        .measure-tool-wrapper {
            position: relative;
            right: 0;

            &.is-active {
                width: fit-content;
                height: 72px;
                opacity: 1;
            }

            div.buttons {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                flex-grow: 1;
            }
        }
    }
</style>
